var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcStartBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20630_5565",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20630_5565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.0066 12.2547C6.89999 12.2547 6.80967 12.2184 6.73563 12.1457C6.6616 12.0731 6.62458 11.983 6.62458 11.8756V7.94592H6.49333C5.97688 7.94592 5.48206 7.84982 5.00888 7.65762C4.5357 7.46542 4.11289 7.18797 3.74046 6.82525C3.35265 6.45055 3.05677 6.01909 2.85282 5.53089C2.64886 5.04269 2.54688 4.53221 2.54688 3.99947V3.52384C2.54688 3.39258 2.59127 3.28254 2.68006 3.19374C2.76887 3.10494 2.8789 3.06055 3.01017 3.06055H3.48579C3.99961 3.06055 4.49041 3.15758 4.95817 3.35165C5.42594 3.54572 5.84604 3.82411 6.21848 4.18682C6.50415 4.46278 6.73992 4.77689 6.92577 5.12913C7.11161 5.48138 7.24192 5.8497 7.3167 6.2341C7.3354 6.18549 7.3569 6.14061 7.38121 6.09948C7.40552 6.05835 7.4345 6.02095 7.46815 5.98729C7.81017 5.49887 8.25486 5.12342 8.80224 4.86096C9.34961 4.59849 9.92462 4.46726 10.5273 4.46726H11.0029C11.1342 4.46726 11.2442 4.51166 11.333 4.60046C11.4218 4.68926 11.4662 4.79929 11.4662 4.93055V5.40619C11.4662 5.93811 11.3641 6.44926 11.16 6.93964C10.9559 7.43001 10.6582 7.86079 10.267 8.23197C9.90429 8.54607 9.5044 8.78706 9.06732 8.95496C8.63022 9.12286 8.17083 9.20681 7.68913 9.20681H7.38288V11.8756C7.38288 11.983 7.34682 12.0731 7.2747 12.1457C7.20258 12.2184 7.11322 12.2547 7.0066 12.2547Z",
    fill: "#6BA9FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStartBadge);
export default __webpack_public_path__ + "static/media/ic-start-badge.ee0fe45582534698197f8d577cb4a907.svg";
export { ForwardRef as ReactComponent };